<mbs-modal
  #modal
  [bodyClasses]="'add-user-modal'"
  [id]="modalId"
  [loading]="initialLoading"
  [title]="'shared:computers.addNewUser' | i18next">
  <ng-container modal-body>
    <form
      class="mbs-form_content"
      [formGroup]="modalForm">
      <mbs-company-select
        class="d-block mb-3"
        formControlName="company"
        [appendTo]="companySelectAppendTo"
        [clearable]="false"
        [label]="'shared:common.company' | i18next: { format: 'title' }"
        [multiple]="false"
        [searchable]="true"
        [selectedId]="preselectedCompanyId"
        [showRequiredMark]="true"></mbs-company-select>

      <mbs-input
        autocomplete="off"
        formControlName="userName"
        [label]="'shared:computers.userName' | i18next"></mbs-input>

      <div class="form-row mt-4 align-items-end">
        <div class="col-8">
          <!-- https://stackoverflow.com/questions/15738259/disabling-chrome-autofill -->
          <mbs-input
            autocomplete="new-password"
            formControlName="password"
            [appendButtons]="appendButtons"
            [label]="'common.password' | i18next: { format: 'title' }"
            [placeholder]="'placeholders.password' | i18next"
            [showErrorsInTooltip]="true"
            [type]="inputType"
            (buttonClick)="onChangePasswordTypeButtonClick()">
          </mbs-input>
        </div>

        <div class="col-4">
          <mbs-button
            type="secondary"
            [loading]="passwordGenerationInProgress"
            (click)="setDefaultPassword()"
            >{{ 'shared:computers.generatePassword' | i18next }}</mbs-button
          >
        </div>
      </div>
    </form>
  </ng-container>
  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [disabled]="requestInProcess"
      [loading]="requestInProcess"
      (click)="onCreateUserButtonClick()">
      {{ 'shared:buttons.create' | i18next }}
    </mbs-button>
    <mbs-button
      type="secondary"
      (click)="modal.close()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
